<template>
  <div class="xueke">
    <div class="title">
      <h1>学科建设</h1>
    </div>
    <ul class="flexDiv">
      <li
        v-for="(item, index) in dataList"
        :key="item.ID"
        class="wow fadeInLeft"
        :data-wow-delay="index / 8 + 's'"
      >
        <a :href="item.Url">
          <p class="imgBox"><img :src="item.Cover" alt="" /></p>
          <span>{{ item.Title }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "tuwen",
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    moreLink: {
      type: String,
      default: ""
    }
  }
};
</script>

<style>
.title {
  text-align: center;
  margin: 40px auto 30px;
}
.title h1 {
  display: inline-block;
  font-size: 22px;
  font-weight: bold;
  color: #333333;
  line-height: 20px;
  letter-spacing: 2px;
  position: relative;
}
.title h1::before {
  content: "";
  width: 65px;
  height: 8px;
  background-image: url(../assets/img/le.png);
  background-size: auto 100%;
  position: absolute;
  right: 106px;
  top: 6px;
}
.title h1::after {
  content: "";
  width: 65px;
  height: 8px;
  background-image: url(../assets/img/ri.png);
  background-size: auto 100%;
  position: absolute;
  left: 106px;
  top: 6px;
}
.xueke ul {
  position: relative;
  flex-wrap: wrap;
}
.xueke ul p.imgBox {
  width: 350px;
  height: 200px;
}
.xueke ul li {
  margin-bottom: 40px;
  width: 350px;
  height: 260px;
  background: #ebebeb;
  box-shadow: 0px 0px 5px 1px rgba(0, 81, 151, 0.4);
  border-radius: 0px 0px 0px 0px;
}
.xueke ul::after {
  content: "";
  width: 379px;
}
.xueke ul span {
  display: block;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 70px;
  position: relative;
}
.xueke ul span::before {
  content: "";
  width: 40px;
  height: 2px;
  background: #0376be;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 54px;
}
</style>



// WEBPACK FOOTER //
// src/components/xueke.vue